/*
===============================================================================
    File        =   dashboard-app/src/app/NavigationMobile.js
    Client      =   Rhealize
    Project     =   Ikimy Platform
    Purpose     =   Navigation bar for mobile 
                    
===============================================================================
    Revision History
        -----------------------------------------------------------------------
        Version Date        Author              Comments
        -----------------------------------------------------------------------
        1.0     2025.02.28  Daniel Rashidian    Initial Creation
        1.1     2025.03.12  Daniel Rashidian    Set up routing for employer page
        -----------------------------------------------------------------------
===============================================================================
*/

import { Flex, Menu, MenuItem } from "@aws-amplify/ui-react";
import { AppLogo } from "../ui-components";
import { useNavigate, useLocation } from "react-router-dom";

const NavigationMobile = ({
    appLink,
    setContactModalVisible

}) => {

    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Flex
            gap="50px"
            direction="row"
            width="100%"
            height="auto"
            justifyContent="flex-start"
            alignItems="center"
            position="relative"
            padding="10px 32px 10px 32px"
            backgroundColor="rgba(244,248,252,1)"
        >
            <AppLogo
                display="flex"
                gap="2.5490198135375977px"
                justifyContent="flex-start"
                alignItems="flex-start"
                position="relative"
                padding="4.078431606292725px 4.078431606292725px 4.078431606292725px 4.078431606292725px"
                darkMode="False"
            />
            <Flex marginLeft="auto">
                <Menu>
                    <MenuItem
                        onClick={(event) => {
                            window.open(`${appLink}`, "_blank");
                        }}
                        children="Login"
                    >
                    </MenuItem>
                    <MenuItem
                        onClick={(event) => {
                            window.open(`${appLink}/signup`, "_blank");
                        }}
                        children="Sign Up"
                    >
                    </MenuItem>
                    {/* <MenuItem>For Employer</MenuItem>
                <MenuItem>About</MenuItem>
                <MenuItem>Blog</MenuItem> */}
                    <MenuItem
                        onClick={(event) => {
                            navigate("/candidate")
                        }}
                        isDisabled={location.pathname === "/candidate" ? true : false}
                        children="For Candidates"
                    >
                    </MenuItem>
                    <MenuItem
                        onClick={(event) => {
                            navigate("/employer")
                        }}
                        isDisabled={location.pathname === "/employer" ? true : false}
                        children="For Employers"
                    >
                    </MenuItem>
                    <MenuItem
                        onClick={(event) => {
                            setContactModalVisible(true);
                        }}
                        children="Contact"
                    >
                    </MenuItem>
                </Menu>
            </Flex>
        </Flex>
    )
};

export default NavigationMobile;